import { memo, type FC } from 'react';
import { useMediaQuery } from 'react-responsive';

import { Media } from '../../../../../theme/Media.tsx';
import Icons from '../../../../Elements/Icons/index.ts';
import { DropdownList } from '../../../DropdownList/index.tsx';
import { TableActionButton } from '../TableActionButton/index.tsx';
import type { TableDropdownListProps } from './types.ts';

export const TableDropdownList: FC<TableDropdownListProps> = memo(function TableDropdownList({
  zIndex = 10,
  buttonLabel = 'More',
  buttonDataTestId,
  isLoading,
  ...restProps
}) {
  const isMobile = useMediaQuery({ query: Media.xsMax });

  return (
    <DropdownList
      zIndex={zIndex}
      isLoading={isLoading}
      renderButton={(isShown) => (
        <TableActionButton dataTestId={buttonDataTestId} disabled={restProps.disabled} isLoading={isLoading}>
          <Icons.More size={20} active={isShown} />
          {isMobile && buttonLabel}
        </TableActionButton>
      )}
      {...restProps}
    />
  );
});
